<template>
  <div class="page-wrapper driver-page-wrapper p-3">
    <div class="">
        <div class="d-flex">
            <h3 class="page-title mb-3">
                    <i class="fa fa-wrench mr-2"></i> LỊCH SỬ SỬA CHỮA
                </h3>

                <button
                    class="btn btn-sm btn-outline-primary"
                    @click="handleReload"
                    :disabled="isLoading"
                >
                    <i class="fa fa-sync-alt mr-1" :class="{ 'fa-spin': isLoading }"></i>
                    Tải lại
                </button>
        </div>
    

    <div class="card card-tabs mb-3">
    <div class="card-header p-0 border-bottom-0">
        <div class="nav-tabs-scrollable">
            <ul class="nav nav-tabs nav-tabs-bottom">
                <!-- Tab Tất cả -->
                <li class="nav-item">
                    <a
                    class="nav-link"
                    href="#"
                    :class="{ active: filterTrangThai === null }"
                    @click.prevent="applyFilter(null)"
                    >
                    Tất cả
                    </a>
                </li>

                <!-- Tab Hoàn thành -->
                <li class="nav-item">
                    <a
                    class="nav-link"
                    href="#"
                    :class="{ active: filterTrangThai === 'HOAN_THANH' }"
                    @click.prevent="applyFilter('HOAN_THANH')"
                    >
                    Hoàn thành
                    </a>
                </li>
            </ul>
        </div>
    </div>
    </div>

      
      <div class="ticket-list">
        <div v-if="isLoading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status"></div>
          <p class="mt-2 mb-0 text-muted">Đang tải danh sách phiếu...</p>
        </div>
        <div v-else-if="error" class="alert alert-danger">
          <i class="fa fa-exclamation-triangle mr-2"></i> {{ error }}
          <button class="btn btn-sm btn-danger ml-2" @click="fetchTickets">Thử lại</button>
        </div>

        <div v-else-if="!filteredTickets.length" class="text-center py-5 text-muted">
          <i class="fa fa-check-circle fa-2x mb-2 text-success"></i>
          <p v-if="filterTrangThai">Không có phiếu nào ở trạng thái "{{ formatTrangThai(filterTrangThai) }}".</p>
          <p v-else>Bạn chưa có phiếu sửa chữa nào.</p>
        </div>
        
        <div v-else class="list-group">
          <a v-for="ticket in filteredTickets" :key="ticket.id"
             href="#" @click.prevent="openDetailModal(ticket.id)"
             class="list-group-item list-group-item-action">
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1 text-primary">
                 {{ truncate(ticket.tenHangMuc || ticket.noiDungCongViec, 40) }}
              </h5>
              <span class="badge" :class="getStatusBadge(ticket.trangThai)">{{ formatTrangThai(ticket.trangThai) }}</span>
            </div>
            <p class="mb-1 text-muted">
               <i class="fa fa-car mr-1"></i> {{ ticket.xeBienSo }} | 
               <span class="badge" :class="getLoaiBadge(ticket.loaiBaoDuong)">{{ formatLoai(ticket.loaiBaoDuong) }}</span>
            </p>
            <small>Tạo ngày: {{ formatDate(ticket.ngayTao) }}</small>
            
            <div class="mt-2" v-if="ticket.chiPhiThucTe || ticket.giaDuocDuyet">
                 <span v-if="ticket.chiPhiThucTe" class="text-danger font-weight-bold">Thực tế: {{ formatCurrency(ticket.chiPhiThucTe) }}</span>
                 <span v-else-if="ticket.giaDuocDuyet" class="text-success">Đã duyệt: {{ formatCurrency(ticket.giaDuocDuyet) }}</span>
            </div>
          </a>
        </div>
      </div>
    </div> <div v-if="showModal" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,.5);">
        <div class="modal-dialog modal-lg" role="document"> 
            <div class="modal-content">
                <div class="modal-header bg-light">
                   <h5 class="modal-title font-weight-bold" v-if="currentTicket">
                     <i class="fa fa-clipboard-list mr-2"></i> Phiếu #{{ currentTicket.id }}: {{ truncate(currentTicket.tenHangMuc || currentTicket.noiDungCongViec, 30) }}
                   </h5>
                   <h5 v-else class="modal-title font-weight-bold">Đang tải...</h5>
                   <button type="button" class="close" @click="closeModal"><span>&times;</span></button>
                </div>
                
                <div v-if="isLoadingDetail" class="modal-body text-center py-5">
                    <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;"></div>
                    <p class="mt-3 text-muted">Đang tải chi tiết...</p>
                </div>
                 <div v-else-if="detailError" class="modal-body">
                    <div class="alert alert-danger">{{ detailError }}</div>
                </div>
                
                <div v-else-if="currentTicket" class="modal-body">
                   <div v-if="formError" class="alert alert-danger py-2">{{ formError }}</div>

                   <div class="mb-3">
                       <h6 class="font-weight-bold">Thông tin Phiếu</h6>
                       <table class="table table-sm table-bordered">
                         <tbody>
                           <tr>
                             <td style="width: 120px;">Trạng thái</td>
                             <td><span class="badge" :class="getStatusBadge(currentTicket.trangThai)">{{ formatTrangThai(currentTicket.trangThai) }}</span></td>
                           </tr>
                           <tr>
                             <td>Xe</td>
                             <td><strong>{{ currentTicket.xeBienSo }}</strong></td>
                           </tr>
                           <tr>
                             <td>Loại</td>
                             <td><span class="badge" :class="getLoaiBadge(currentTicket.loaiBaoDuong)">{{ formatLoai(currentTicket.loaiBaoDuong) }}</span></td>
                           </tr>
                           <tr>
                             <td>Nội dung</td>
                             <td>{{ currentTicket.noiDungCongViec }}</td>
                           </tr>
                           <tr v-if="currentTicket.anhSuCoUrl">
                             <td>Ảnh sự cố</td>
                             <td><a :href="currentTicket.anhSuCoUrl" target="_blank" rel="noopener">Xem ảnh <i class="fa fa-external-link-alt"></i></a></td>
                           </tr>
                           <tr>
                             <td>Gara</td>
                             <td>{{ currentTicket.garaDeXuat || '-' }}</td>
                           </tr>
                           <tr>
                             <td>Giá duyệt</td>
                             <td class="font-weight-bold text-success">{{ formatCurrency(currentTicket.giaDuocDuyet) }}</td>
                           </tr>
                            <tr v-if="currentTicket.trangThai === 'HOAN_THANH' || currentTicket.trangThai === 'CHO_THANH_TOAN'">
                             <td>Chi phí thực tế</td>
                             <td class="font-weight-bold text-danger">{{ formatCurrency(currentTicket.chiPhiThucTe) }}</td>
                           </tr>
                            <tr v-if="currentTicket.trangThai === 'HOAN_THANH'">
                             <td>Ghi chú TT</td>
                             <td>{{ currentTicket.ghiChuThanhToan || '-' }}</td>
                           </tr>
                         </tbody>
                       </table>
                   </div>
                   
                   <div class="action-zone mt-4">
         <div v-if="currentTicket.trangThai === 'MOI'" class="p-3 bg-light rounded">
    <h5><i class="fa fa-dollar-sign mr-2"></i>Gửi Báo giá</h5>
    <p class="small text-muted">Admin/Tài xế liên hệ gara và nhập báo giá để chờ duyệt.</p>
    
    <form @submit.prevent="handleSubmitBaoGia(currentTicket.id)">
        <div class="form-group">
            <label>Tên Gara / Nơi sửa <span class="text-danger">*</span></label>
            <input v-model.trim="formGia.garaDeXuat" class="form-control" required>
        </div>
        <div class="form-group">
            <label>Chi phí dự kiến (VND) <span class="text-danger">*</span></label>
            <input v-model.number="formGia.giaDeXuat" type="number" class="form-control" min="1" required>
        </div>

        <div class="form-group">
            <label>Ảnh chụp Báo giá/Biên lai (Nếu có)</label>
            
            <div v-if="formGia.anhBaoGiaUrl" class="mb-2">
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control" :value="formGia.anhBaoGiaUrl" readonly>
                    <div class="input-group-append">
                        <button type="button" class="btn btn-outline-danger" @click="formGia.anhBaoGiaUrl = null">Xóa</button>
                    </div>
                </div>
            </div>

            <div v-else class="btn-group">
                <!-- <button type="button" class="btn btn-outline-primary btn-sm" @click="openPicker('formGia_anhBaoGiaUrl')">
                    <i class="fa fa-upload mr-1"></i> Tải lên / Chọn
                </button> -->
                
             <CameraCapture
                                                v-model="formGia.anhBaoGiaUrl"
                                                folder-name="bao_duong_bao_gia" 
                                                file-name-prefix="bao-gia"
                                                modal-title="Chụp ảnh Báo Giá"
                                                button-text="Chụp ảnh"
                                                facing-mode="environment"

                                                button-class="btn-sm btn-outline-secondary" 
                                                :disabled="isLoadingDetail"
                                            />
            </div>
        </div>
        <button type="submit" class="btn btn-warning btn-block" :disabled="isLoadingDetail">
            <span v-if="isLoadingDetail" class="spinner-border spinner-border-sm"></span>
            <i v-else class="fa fa-paper-plane"></i> Gửi Báo giá
        </button>
    </form>
</div>

                       <div v-if="currentTicket.trangThai === 'CHO_DUYET'" class="p-3 bg-light rounded text-center">
                           <i class="fa fa-gavel fa-2x text-warning mb-2"></i>
                           <p class="font-weight-bold">Đang chờ Admin duyệt giá</p>
                           <p class="mb-0">Giá đề xuất: <strong>{{ formatCurrency(currentTicket.giaDeXuat) }}</strong></p>
                       </div>
                       
                       <div v-if="currentTicket.trangThai === 'DA_DUYET'" class="p-3 bg-light rounded">
                           <h6 class="font-weight-bold">Sẵn sàng Sửa chữa</h6>
                           <div class="alert alert-success py-2 small">
                               Đã duyệt chi phí: <strong>{{ formatCurrency(currentTicket.giaDuocDuyet) }}</strong>
                           </div>
                           <button type="button" class="btn btn-primary btn-block" :disabled="isLoadingDetail" @click="handleBatDauSua(currentTicket.id)">
                               <span v-if="isLoadingDetail" class="spinner-border spinner-border-sm"></span>
                               <i class="fa fa-play-circle"></i> Bắt đầu Sửa chữa
                           </button>
                       </div>
                       
                        <div v-if="currentTicket.trangThai === 'DANG_SUA'" class="p-3 bg-light rounded">
                            <h5><i class="fa fa-check-square mr-2"></i>Xác nhận Hoàn thành</h5>
                            <p class="small text-muted">Tài xế/Admin nhập thông tin sau khi gara sửa xong.</p>
                            
                            <form @submit.prevent="handleHoanThanh(currentTicket.id)">
                                <div class="form-group">
                                    <label>ODO lúc hoàn thành (Km) <span class="text-danger"></span></label>
                                    <input v-model.number="formHoanThanh.odoHoanThanh" type="number" class="form-control" min="1" required>
                                </div>
                                <div class="form-group">
                                    <label>Chi phí thực tế (VND) <span class="text-danger">*</span></label>
                                    <input v-model.number="formHoanThanh.chiPhiThucTe" type="number" class="form-control" min="1" required>
                                </div>
                                
                                <div class="form-group">
                                    <label>Ảnh chụp Biên lai/Hóa đơn (URL) <span class="text-danger">*</span></label>
                                    
                                    <div v-if="formHoanThanh.bienLaiUrl" class="mb-2">
                                        <div class="input-group input-group-sm">
                                            <input type="text" class="form-control" :value="formHoanThanh.bienLaiUrl" readonly>
                                            <div class="input-group-append">
                                                <button type="button" class="btn btn-outline-danger" @click="formHoanThanh.bienLaiUrl = null">Xóa</button>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-else class="btn-group">
                                        <!-- <button type="button" class="btn btn-outline-primary btn-sm" @click="openPicker('bienLaiUrl')">
                                            <i class="fa fa-upload mr-1"></i> Tải lên / Chọn
                                        </button> -->
                                        
                                        <CameraCapture
                                            v-model="formHoanThanh.bienLaiUrl"
                                            folder-name="bao_duong_bien_lai" 
                                            file-name-prefix="bien-lai"
                                            modal-title="Chụp ảnh Biên Lai"
                                            facing-mode="environment"

                                            button-text="Chụp ảnh"
                                            button-class="btn-sm btn-outline-secondary" 
                                            :disabled="isLoadingDetail"
                                        />
                                    </div>
                                    
                                    <input 
                                    type="text" 
                                    :value="formHoanThanh.bienLaiUrl" 
                                    required 
                                    style="width:0; height:0; padding:0; border:none; opacity: 0; position: absolute;" 
                                    tabindex="-1"
                                    aria-hidden="true"
                                    @focus.prevent
                                    >
                                </div>
                                <button type="submit" class="btn btn-info btn-block" :disabled="isLoadingDetail">
                                    <span v-if="isLoadingDetail" class="spinner-border spinner-border-sm"></span>
                                    <i v-else class="fa fa-flag-checkered"></i> Gửi Xác nhận Hoàn thành
                                </button>
                            </form>
                        </div>
                       
                       <div v-if="currentTicket.trangThai === 'CHO_THANH_TOAN'" class="p-3 bg-light rounded text-center">
                           <i class="fa fa-file-invoice-dollar fa-2x text-danger mb-2"></i>
                           <p class="font-weight-bold">Đã gửi, chờ Kế toán thanh toán</p>
                           <p class="mb-0">Chi phí báo cáo: <strong>{{ formatCurrency(currentTicket.chiPhiThucTe) }}</strong></p>
                       </div>
                       
                       <div v-if="currentTicket.trangThai === 'HOAN_THANH' || currentTicket.trangThai === 'DA_HUY'" class="p-3 bg-light rounded text-center text-muted">
                            <i class="fa fa-check-circle fa-2x mb-2 text-success" v-if="currentTicket.trangThai === 'HOAN_THANH'"></i>
                            <i class="fa fa-times-circle fa-2x mb-2 text-secondary" v-if="currentTicket.trangThai === 'DA_HUY'"></i>
                            <p>Phiếu này đã được đóng.</p>
                       </div>
                       
                   </div>
                </div>
                 <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeModal">Đóng</button>
                 </div>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'pinia';
import { useDriverBaoDuongStore } from '@/stores/driverBaoDuongStore'; // Import store TÀI XẾ
import api from '@/api'; // Import api để fetch folders
import fileService from '@/services/fileService'; // Import service upload

// --- IMPORT CÁC COMPONENT CON ---
import SosComponent from './SosComponent.vue'; 
import FileManagerModal from '@/components/FileManagerModal.vue';
import CameraCapture from '@/components/CameraCapture.vue';

// --- Helpers (Copy từ file Admin) ---
function pad2(n) { return String(n).padStart(2, '0'); }
function parseIsoLocal(s) {
    if (!s) return null;
    if (s instanceof Date) return s;
    const m = String(s).match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/);
    if (!m) return null;
    const [, y, M, d, h, mi, se] = m;
    return new Date(+y, +M - 1, +d, +h, +mi, +se);
}
function formatDate(s) {
    const d = parseIsoLocal(s);
    if (!d) return '-';
    const dd = pad2(d.getDate());
    const MM = pad2(d.getMonth() + 1);
    const yyyy = d.getFullYear();
    return `${dd}/${MM}/${yyyy}`;
}
function formatDateTime(s) {
    const d = parseIsoLocal(s);
    if (!d) return '-';
    const dd = pad2(d.getDate());
    const MM = pad2(d.getMonth() + 1);
    const yyyy = d.getFullYear();
    const hh = pad2(d.getHours());
    const mm = pad2(d.getMinutes());
    return `${dd}/${MM}/${yyyy} ${hh}:${mm}`;
}
function formatCurrency(value) {
    if (value == null || isNaN(Number(value))) return '-';
    return Number(value).toLocaleString('vi-VN') + ' đ';
}
// --- Hết Helpers ---

export default {
  name: 'BaoDuongCuaToi', // Tên component (Trang của tài xế)
  components: {
      SosComponent, // Đăng ký component SOS
      FileManagerModal, // Đăng ký File Manager
      CameraCapture, // Đăng ký Camera
  },
  data() {
    return {
      showModal: false,
      formError: null,
      currentProcessingId: null, // Để biết phiếu nào đang submit
      filterTrangThai: null, // null = Tất cả

      // Form Giai đoạn 2: Báo giá
      formGia: {
          garaDeXuat: '',
          giaDeXuat: null,
          anhBaoGiaUrl: null, // Thêm
      },
      // Form Giai đoạn 4: Hoàn thành
      formHoanThanh: {
          odoHoanThanh: null,
          chiPhiThucTe: null,
          bienLaiUrl: '',
      },
      
      // --- State cho FILE MANAGER & CAMERA ---
      pickerOpen: false,    // Mở FileManagerModal
      cameraOpen: false,    // Mở CameraCapture
      pickerFolder: 'bao_duong', // Folder mặc định
      pickerTarget: {     // Lưu trữ mục tiêu (form nào, trường nào)
          form: null, 
          field: null,
      },
      folderTabs: [],       // Danh sách folder cho FileManagerModal
      uploading: false,     // Trạng thái đang upload (dùng chung cho Camera)
    };
  },
  computed: {
    // Map state từ store TÀI XẾ
    ...mapState(useDriverBaoDuongStore, [
      'isLoading', // Loading danh sách
      'error',     // Lỗi danh sách
      'tickets',   // Danh sách TOÀN BỘ phiếu
      'isLoadingDetail',
      'detailError',
      'currentTicket', // Phiếu đang xem trong modal
    ]),
    
    // Computed để lọc client-side
     filteredTickets() {
    // Tab "Hoàn thành"
    if (this.filterTrangThai === 'HOAN_THANH') {
      return this.tickets.filter(t => t.trangThai === 'HOAN_THANH');
    }

    // Tab "Tất cả" (đang mở) => loại bỏ đã hoàn thành & đã hủy
    return this.tickets.filter(
      t => t.trangThai !== 'HOAN_THANH' && t.trangThai !== 'DA_HUY'
    );
    }
  },
  
  methods: {
    // Map actions từ store TÀI XẾ
    ...mapActions(useDriverBaoDuongStore, [
      'fetchTickets',
      'openTicketDetail', // Dùng action này
      'clearTicketDetail', // Dùng action này
      'driverSubmitGia',
      'driverStartSuaChua',
      'driverCompleteSuaChua',
    ]),

      handleReload() {
    this.fetchTickets();
  },

    // --- Helpers Format ---
    formatDate,
    formatDateTime,
    formatCurrency,
    getStatusBadge(status) {
        switch (status) {
            case 'MOI': return 'badge-light';
            case 'CHO_DUYET': return 'badge-warning';
            case 'DA_DUYET': return 'badge-info';
            case 'DANG_SUA': return 'badge-primary';
            case 'CHO_THANH_TOAN': return 'badge-danger';
            case 'HOAN_THANH': return 'badge-success';
            case 'DA_HUY': return 'badge-secondary';
            default: return 'badge-light';
        }
    },
    formatTrangThai(status) {
        switch (status) {
            case 'MOI': return 'Mới tạo';
            case 'CHO_DUYET': return 'Chờ duyệt';
            case 'DA_DUYET': return 'Đã duyệt';
            case 'DANG_SUA': return 'Đang sửa';
            case 'CHO_THANH_TOAN': return 'Chờ TT';
            case 'HOAN_THANH': return 'Hoàn thành';
            case 'DA_HUY': return 'Đã hủy';
            default: return status;
        }
    },
    getLoaiBadge(loai) {
        switch (loai) {
            case 'DINH_KY': return 'badge-info';
            case 'TU_CHECKLIST': return 'badge-warning';
            case 'SU_CO_DOT_XUAT': return 'badge-danger';
            default: return 'badge-light';
        }
    },
    formatLoai(loai) {
         switch (loai) {
            case 'DINH_KY': return 'Định kỳ';
            case 'TU_CHECKLIST': return 'Checklist';
            case 'SU_CO_DOT_XUAT': return 'Sự cố';
            default: return loai;
        }
    },
    truncate(text, length) {
        if (!text) return '';
        const strText = String(text); 
        if (strText.length <= length) {
            return strText;
        }
        return strText.substring(0, length) + '...';
    },

    // --- Logic Giao diện ---
    applyFilter(status) {
        this.filterTrangThai = status;
    },
    handleSosSuccess() {
        this.fetchTickets();
        alert("Đã gửi báo cáo SOS thành công! Phiếu mới đã được tạo.");
    },
     viewFile(url) {
      if (url) {
        window.open(url, '_blank', 'noopener,noreferrer');
      } else {
        alert('Chưa có file đính kèm.');
      }
    },

    // --- Logic Modal Chi Tiết ---
    async openDetailModal(ticketId) {
        this.formError = null;
        this.formGia = { garaDeXuat: '', giaDeXuat: null, anhBaoGiaUrl: null }; // Reset
        this.formHoanThanh = { odoHoanThanh: null, chiPhiThucTe: null, bienLaiUrl: '' };
        
        this.showModal = true;
        document.body.style.overflow = 'hidden';
        
        await this.openTicketDetail(ticketId); // Gọi action store

        // Điền sẵn form
        if (this.currentTicket) {
           this.formGia.garaDeXuat = this.currentTicket.garaDeXuat;
           this.formGia.giaDeXuat = this.currentTicket.giaDeXuat;
           this.formGia.anhBaoGiaUrl = this.currentTicket.anhBaoGiaUrl; // Thêm
           this.formHoanThanh.odoHoanThanh = this.currentTicket.odoHoanThanh;
           this.formHoanThanh.chiPhiThucTe = this.currentTicket.chiPhiThucTe;
           this.formHoanThanh.bienLaiUrl = this.currentTicket.bienLaiUrl;
        }
    },
    closeModal() {
        this.showModal = false;
        this.clearTicketDetail();
        document.body.style.overflow = '';
    },

    // --- Logic Submit Forms (Tài xế) ---
    async handleSubmitBaoGia(ticketId) {
      this.formError = null;
      this.currentProcessingId = ticketId;
      if (!this.formGia.garaDeXuat || !this.formGia.giaDeXuat || this.formGia.giaDeXuat <= 0) {
          this.formError = "Vui lòng nhập Gara và Giá đề xuất (phải > 0)."; 
          this.currentProcessingId = null;
          return;
      }
      try {
          await this.driverSubmitGia(ticketId, this.formGia);
          alert('Gửi báo giá thành công, chờ Admin duyệt.');
          await this.openTicketDetail(ticketId); // Tải lại chi tiết
      } catch (e) {
          this.formError = this.detailError || "Lỗi gửi báo giá.";
      } finally {
          this.currentProcessingId = null;
      }
    },
    
    async handleBatDauSua(ticketId) {
         this.formError = null;
         this.currentProcessingId = ticketId;
         if (!confirm("Xác nhận Gara bắt đầu sửa chữa?")) {
             this.currentProcessingId = null;
             return;
         }
         try {
             await this.driverStartSuaChua(ticketId);
             alert('Đã cập nhật trạng thái "Đang Sửa".');
             await this.openTicketDetail(ticketId);
         } catch (e) {
             this.formError = this.detailError || "Lỗi bắt đầu sửa chữa.";
         } finally {
            this.currentProcessingId = null;
         }
    },
    
    async handleHoanThanh(ticketId) {
        this.formError = null;
        this.currentProcessingId = ticketId;
        if (!this.formHoanThanh.chiPhiThucTe || !this.formHoanThanh.bienLaiUrl) {
            this.formError = "Vui lòng nhập Chi phí thực tế và Ảnh biên lai.";
            this.currentProcessingId = null;
            return;
        }
         if (this.formHoanThanh.chiPhiThucTe <= 0) {
             this.formError = " Chi phí phải là số dương.";
             this.currentProcessingId = null;
             return;
        }
        if (!confirm("Xác nhận Gara đã sửa xong?")) {
            this.currentProcessingId = null;
            return;
        }
        try {
            await this.driverCompleteSuaChua(ticketId, this.formHoanThanh);
             alert('Xác nhận hoàn thành thành công, chờ Kế toán thanh toán.');
             await this.openTicketDetail(ticketId);
        } catch (e) {
             this.formError = this.detailError || "Lỗi xác nhận hoàn thành.";
        } finally {
            this.currentProcessingId = null;
        }
    },

    // --- ================================== ---
    // --- === LOGIC FILE MANAGER & CAMERA === ---
    // --- ================================== ---
    
    // (Hàm này copy từ QuanLyBaoDuong (Admin) về)
    async fetchFolders() {
      try {
        this.uploading = true;
        const { data } = await api.get('/api/images/folders'); 
        this.folderTabs = (data || []).map((folderName, index) => ({
          id: (index + 1).toString(),
          name: folderName,
          folderName,
        }));
      } catch {
        this.folderTabs = [];
        console.error('Lỗi khi tải danh sách folder.');
      } finally {
          this.uploading = false;
      }
    },
    
    // (Hàm này copy từ QuanLyBaoDuong (Admin) về)
    async openPicker(targetKey) { 
      if (targetKey === 'formGia_anhBaoGiaUrl') {
           this.pickerTarget = { form: this.formGia, field: 'anhBaoGiaUrl' };
           this.pickerFolder = 'bao_duong_bao_gia';
      } else if (targetKey === 'bienLaiUrl') {
          this.pickerTarget = { form: this.formHoanThanh, field: 'bienLaiUrl' };
          this.pickerFolder = 'bao_duong_bien_lai';
      } else { return; }
      
      await this.fetchFolders();
      this.pickerOpen = true;
      document.body.style.overflow = 'hidden';
    },

    // (Hàm này copy từ QuanLyBaoDuong (Admin) về)
    closePicker() {
      this.pickerOpen = false;
      document.body.style.overflow = 'hidden'; // Giữ lock
    },

    // (Hàm này copy từ QuanLyBaoDuong (Admin) về)
    handleFilePicked(image) {
      if (!image || !image.url) return;
      if (this.pickerTarget.form && this.pickerTarget.field) {
          this.pickerTarget.form[this.pickerTarget.field] = image.url;
      }
      this.closePicker();
    },

    // (Hàm này copy từ QuanLyBaoDuong (Admin) về)
    openCamera(targetKey) {
        if (targetKey === 'formGia_anhBaoGiaUrl') {
           this.pickerTarget = { form: this.formGia, field: 'anhBaoGiaUrl' };
           this.pickerFolder = 'bao_duong_bao_gia';
        } else if (targetKey === 'bienLaiUrl') {
          this.pickerTarget = { form: this.formHoanThanh, field: 'bienLaiUrl' };
          this.pickerFolder = 'bao_duong_bien_lai';
        } else { return; }
        
        this.cameraOpen = true;
        document.body.style.overflow = 'hidden';
    },

    // (Hàm này copy từ QuanLyBaoDuong (Admin) về)
    closeCamera() {
        this.cameraOpen = false;
        document.body.style.overflow = 'hidden'; // Giữ lock
    },

    // (Hàm này copy từ QuanLyBaoDuong (Admin) về)
    async handleCaptureSuccess(file) {
        this.closeCamera();
        if (!file) return;
        
        this.uploading = true; 
        this.formError = null;
        try {
            const formData = new FormData();
            formData.append("files", file, file.name || 'camera-capture.jpg');
            formData.append("folderName", this.pickerFolder);

            const res = await fileService.upload(formData);
            const first = Array.isArray(res.data) ? res.data[0] : null;
            if (first?.location) {
                if (this.pickerTarget.form && this.pickerTarget.field) {
                    this.pickerTarget.form[this.pickerTarget.field] = first.location;
                }
            } else {
                throw new Error("Server không trả về URL file.");
            }
        } catch (err) {
             let errorMsg = err?.response?.data?.error || err?.response?.data?.message || err?.message || "Upload ảnh thất bại";
             console.error("[Upload Camera]", err);
             this.formError = errorMsg; // Hiển thị lỗi lên modal
        } finally {
            this.uploading = false;
        }
    },
    
    // (Hàm này copy từ QuanLyBaoDuong (Admin) về)
    handleCaptureError(error) {
        this.closeCamera();
        this.formError = "Lỗi Camera: " + (error.message || 'Không thể truy cập camera');
    }
  },

  mounted() {
    this.fetchTickets(); // Tải danh sách phiếu của tài xế
  }
};
</script>

<style scoped>
.driver-page-wrapper {
  max-width: 900px; /* Giới hạn chiều rộng cho dễ nhìn trên mobile/tablet */
  margin: 0 auto;
}
.page-title {
  color: #333;
}
.card-header {
  font-size: 1.1rem;
  background-color: #fff;
}

/* Style cho Tab (Quan trọng) */
.nav-tabs-scrollable {
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch; /* Cho iOS */
    scrollbar-width: none; /* Ẩn scrollbar Firefox */
}
.nav-tabs-scrollable::-webkit-scrollbar {
    display: none; /* Ẩn scrollbar Chrome/Safari */
}
.nav-tabs-scrollable .nav-tabs {
    flex-wrap: nowrap; /* Ngăn tab xuống dòng */
    margin-bottom: 0;
    border-bottom: 1px solid #dee2e6; /* Thêm đường viền dưới */
}
.nav-tabs-scrollable .nav-item {
    flex-shrink: 0; /* Không co tab lại */
}
.nav-tabs .nav-link {
    font-weight: 500;
    color: #495057;
    border: none; /* Bỏ border mặc định */
    border-bottom: 3px solid transparent;
    padding: 0.75rem 0.5rem; /* Giảm padding ngang cho mobile */
    margin: 0 5px; /* Thêm khoảng cách giữa các tab */
}
.nav-tabs .nav-link.active {
    font-weight: 700;
    color: #0d6efd;
    border-color: transparent transparent #0d6efd transparent;
    background-color: transparent;
}


/* Style cho danh sách List Group (thay cho card) */
.list-group-item strong {
    color: #0d6efd;
}
.list-group-item:hover {
    background-color: #f8f9fa;
}

/* Style cho badge */
.badge {
    padding: 0.4em 0.6em;
    font-size: 0.75rem; /* Nhỏ hơn 1 chút cho mobile */
    font-weight: 500;
}
/* Trạng thái Phiếu */
.badge-light { background-color: #f8f9fa; color: #6c757d; border: 1px solid #dee2e6; } /* Mới */
.badge-warning { background-color: #ffc107; color: #000; } /* Chờ duyệt, Sự cố CL */
.badge-info { background-color: #0dcaf0; color: #000; } /* Đã duyệt, Định kỳ */
.badge-primary { background-color: #0d6efd; color: #fff;} /* Đang sửa */
.badge-danger { background-color: #dc3545; color: #fff;} /* Chờ TT, Sự cố SOS */
.badge-success { background-color: #198754; color: #fff;} /* Hoàn thành */
.badge-secondary { background-color: #6c757d; color: #fff;} /* Hủy */

/* Style cho bảng chi tiết */
.table-bordered td:first-child {
    background-color: #f8f9fa;
    font-weight: 500;
    width: 120px;
}
/* Style cho nút spinner */
.btn .spinner-border {
    width: 1em;
    height: 1em;
    vertical-align: text-bottom;
}
/* Chống scroll body khi modal mở */
body.modal-open {
    overflow: hidden !important;
    padding-right: 0 !important;
}
.modal-body {
    max-height: 75vh;
    overflow-y: auto;
}
</style>